(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlComboKeyValue', [])
        .directive('dynamicComboKeyValue', ['adminMetadataService', 'errorsExtend', '$filter',
            function (adminMetadataService, errors, $filter) {
                return {
                    replace: true,
                    restrict: 'E',
                    templateUrl: '/app/directives/custom-control-combo-key-value/custom-control-combo-key-value-template.html',
                    controller: [
                        '$scope', function ($scope) {
                            $scope.value = '';
                            $scope.description = '';
                            $scope.hasInactiveItems = false;

                            if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                                $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                            }

                            function getActives(option) {
                                return option.active === undefined ? true : option.active;
                            }

                            if ($scope.hideinactive) {
                                var activeItems = $scope.data.metadataOptions.filter(getActives);
                                $scope.data.metadataOptions = activeItems;
                            } else {
                                var item = $filter('filter')($scope.data.metadataOptions, { value: $scope.data.metadataValue, active: false }, true);
                                if (item.length > 0) {
                                    $scope.hasInactiveItems = true;
                                }
                            }

                            $scope.selectMetadata = function (metadata) {
                                var active = metadata ? true : metadata.active === undefined ? true : metadata.active;
                                $scope.hasInactiveItems = !active;
                            };

                            $scope.save = function () {
                                if (this.$parent.value) {
                                    var item = {
                                        metadataId: this.$parent.data.metadataId,
                                        key: this.$parent.value,
                                        description: this.$parent.description
                                    };
                                    adminMetadataService.addMetadataValues(item).then(function (result) {
                                        $scope.addToOptions(result);
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }
                                else {
                                    errors.showError('VerifyFormData');
                                }
                            };

                            $scope.cancel = function () {
                                this.value = '';
                                this.description = '';
                            }

                            $scope.addToOptions = function (result) {
                                this.data.metadataOptions.push({ value: result.key, description: result.description });
                                this.value = '';
                                this.description = '';
                                $('#addItemModal' + this.data.metadataId).modal('hide');
                            };
                        }]
                };
            }]);

    angular.module('CustomControlComboKeyValue')
        .directive('dynamicFilterComboKeyValue', ['$translate', function () {
            return {
                templateUrl: '/app/directives/custom-control-combo-key-value/custom-control-filter-combo-key-value-template.html',
                replace: true,
                restrict: 'E',
                controller: [
                    '$scope', function ($scope) {
                        if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                            $scope.data.metadataSearchTypeFrom = 'Equal';
                        }

                        if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                            $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                        }

                    }
                ],
                link: function (scope, iElement, iAttrs, formCtrl) {
                    scope.filterNullValue = iAttrs.filternullvalue;
                }
            };
        }]);
})();